import { takeLatest, put, call } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import { routePath } from 'app/services/helpers'
import axios from 'app/services/http/axios';

// -------

import {Actions} from './slice';
import { Api } from 'modules/Admin/Companies'

// -------

function* getCompany({payload: {id}}) {
  try {
    const route = routePath(Api.company, { id })

    const response = yield call(axios.get, route);
    yield put(Actions.getCompanySuccess(response));

  } catch (e) {
    return yield put(Actions.getCompanyFailed(e));
  }
}

function* save({ payload: {id, values} }) {

  console.log('id', id)
  console.log('values', values)

  try {

    if ( id === 0 ) id = 'create'
    const route = routePath(Api.company, { id })

    // Handle file upload for logo
    const formData = new FormData();

    // Append all form fields
    Object.keys(values).forEach(key => {
      if (key === 'logo' && values[key] && values[key].length > 0) {
        // Handle file upload - check if it's a FileList
        console.log('Logo file:', values[key][0]);
        formData.append('logo', values[key][0]);
      } else if (key !== 'logo' && values[key] !== null && values[key] !== undefined && values[key] !== '') {
        formData.append(key, values[key]);
      }
    });

    // Log FormData contents for debugging
    console.log('FormData contents:');
    for (let pair of formData.entries()) {
      console.log(pair[0], pair[1]);
    }

    // Don't set Content-Type header - let browser set it with boundary
    const response = yield call(axios.post, route, formData);

    yield put(Actions.saveFormSuccess(response));

    toast.success('Company has been successfully saved')

  } catch (e) {
    console.error('Save error:', e);
    return yield put(Actions.saveFormFailed(e));
  }
}

export function* watchCompaniesFormSaga() {
  yield takeLatest(Actions.getCompany.type, getCompany)
  yield takeLatest(Actions.saveForm.type, save)
}

export default watchCompaniesFormSaga

